// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SimilarStrollers__headline":"xx_a bie_vp bie_vh bie_xe bie_rg bie_tr bie_qx"};